import React, { useState } from 'react';

const UserList = ({ users, onEdit, onRemove, isConductor }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredUsers = users.filter(user =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">Usuarios</h2>
        <input
          type="text"
          placeholder="Buscar usuario..."
          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredUsers.map(user => (
          <div key={user.email} className="relative bg-white rounded-xl shadow-md p-6 flex flex-col">
            <div className="flex items-center mb-2">
              <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg">
                {user.name ? user.name[0].toUpperCase() : "U"}
              </div>
              <div className="ml-4">
                <div className="font-semibold text-lg">{user.name}</div>
                <div className="text-gray-500 text-sm">{user.email}</div>
              </div>
            </div>
            <div className="flex-1">
              <div className="text-sm text-gray-700 mb-1">
                <span className="font-medium">Rol:</span> {user.role}
              </div>
              <div className="text-sm text-gray-700 mb-1">
                <span className="font-medium">Estado:</span> {user.status}
              </div>
            </div>
            {/* Only show edit/delete if NOT conductor */}
            {!isConductor && (
              <div className="absolute top-2 right-2 flex gap-2">
                <button
                  onClick={() => onEdit(user)}
                  className="bg-yellow-500 text-white rounded-full p-1 hover:bg-yellow-600 transition-colors"
                  aria-label="Editar usuario"
                >
                  {/* Edit icon (pencil) */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536M9 13h3l8-8a2.828 2.828 0 10-4-4l-8 8v3z" />
                  </svg>
                </button>
                <button
                  onClick={() => onRemove(user.email)}
                  className="bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors"
                  aria-label="Eliminar usuario"
                >
                  {/* X icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserList;